import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/calculate-payrolls',
    name: 'calculate-payroll',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/calculate-payroll/index.vue')
  }
]
